// Field labels reuse the existing Settings and voice copy. No new presentation.
import { APP_COPY } from '@/i18n/catalogs';
import voiceCopy from '@/i18n/ns/voice';
import type { EuAppLanguage } from '@/i18n/eu-locales';

export function personalSettingsFields(locale: string): Record<string, string> {
  const lang = locale.split('-')[0] as EuAppLanguage;
  const voice = voiceCopy[lang] ?? voiceCopy.en;
  const chrome = APP_COPY[lang] ?? APP_COPY.en;
  return {
    personality: chrome.personality,
    voice_prefs: voice.settingsTitle,
    enabled: voice.enabledLabel,
    readAloud: voice.readAloudInVoice,
    speakWith: voice.speakWith,
    rate: voice.rate,
    undoMs: voice.undoWindow,
    endpointDelayMs: voice.waitBeforeSending,
    endpoint: voice.undoWindow,
    spokenApprovals: voice.spokenApprovalsLabel,
    fullDuplex: 'Speak while Poneva speaks',
  };
}
